import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { typedFetch } from '../../typedFetch';
import './Users.scss';
export const Users = ({ appendToErrorLog, loggedInUser, }) => {
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    useEffect(() => {
        if (!loggedInUser) {
            appendToErrorLog('Only logged-in users may see the list of users');
            setLoading(false);
            return;
        }
        typedFetch('get-user', {
            body: { all: true },
        })
            .then((result) => {
            if (result.success) {
                setUsers(result.users);
            }
            else {
                appendToErrorLog(`Failed to retrieve list of users: ${result.reason}`);
            }
            setLoading(false);
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error while retrieving list of users: ${String(error['message'])}`);
            setLoading(false);
        });
    }, [appendToErrorLog, loggedInUser]);
    if (loading) {
        return 'Retrieving users...';
    }
    if (!users.length) {
        return 'No users to display';
    }
    return (_jsxs("div", { className: "users", children: [_jsxs("div", { children: [_jsx("div", { children: "Name" }), _jsx("div", { children: "Email" }), _jsx("div", { children: "Departments" }), _jsx("div", { children: "Supervisor" }), _jsx("div", { children: "Enabled" })] }), users.map(user => (_jsxs("div", { className: user.enabled ? '' : 'disabled', children: [_jsx("a", { href: `users/${user.email.match(/^[^@]+/)[0]}`, children: user.name }), _jsx("div", { title: `User identifier: ${user.guid}`, children: user.email }), _jsx("div", { children: user.departments.join(', ') }), _jsx("div", { children: user.supervisor ? '✓' : '' }), _jsx("div", { children: user.enabled ? '✓' : '' })] }, user.guid))), loggedInUser?.supervisor ? _jsx("button", { onClick: () => { window.location.href = 'users/new'; }, children: "Add New User" }) : null] }));
};
